import { useEffect, useState } from 'react'
import { loadMediaUrl } from '../lib/media'

export type MediaUrlState = { url: string | null; loading: boolean; error: boolean }

/** Resolves a bearer-authenticated `/api/media/…` path into an object URL. */
export function useMediaUrl(path: string | null | undefined): MediaUrlState {
  const [state, setState] = useState<MediaUrlState>({ url: null, loading: Boolean(path), error: false })

  useEffect(() => {
    if (!path) {
      setState({ url: null, loading: false, error: false })
      return
    }
    let active = true
    setState({ url: null, loading: true, error: false })
    loadMediaUrl(path)
      .then((url) => {
        if (active) setState({ url, loading: false, error: false })
      })
      .catch(() => {
        if (active) setState({ url: null, loading: false, error: true })
      })
    return () => {
      active = false
    }
  }, [path])

  return state
}
